import * as React from "react";
import {Link}     from "react-router-dom";

import "./office-admin-layout.scss";

import {cs}             from "@Common/react/chain-services";
import {consumeContext} from "@Common/react/context";
import {Responsive}     from "@Common/ui-components/responsive";
import {buildUrlQuery}  from "@Common/utils/build-url-query";
import {omit}           from "@Common/utils/objects";
import {parseUrlQuery}  from "@Common/utils/parse-url-query";

import {InternalLink} from "@Xpresso/routes/common/components/internal-link";

import {AccountTabsLayout} from "../../../common/account-tabs-layout/account-tabs-layout";
import {ManagementModal}   from "../../office-management/office-management-route/management-modal/management-modal";
import {HeaderMobile} from "./header-mobile";

export const OfficeAdminLayout = ({activeTab, officeId, office, reload, next}) => cs(
    consumeContext("accountMenu"),
    consumeContext("routerHistory"),
    ["queryParams", ({}, next) => next(parseUrlQuery(window.location.search))],
    ["baseUrl", ({}, next) => next(items.find((item) => activeTab === item.name)?.link)],
    ({queryParams, baseUrl, routerHistory}, next) => <>
        <ManagementModal
            branchId={queryParams?.office}
            onClose={() => {
                reload()
                routerHistory.replace(`${baseUrl}${buildUrlQuery({...omit(queryParams, ['menu','modal'])})}`)
            }}
            onTabSwitch={(tabName) => (
                routerHistory.replace(`${baseUrl}${buildUrlQuery({...queryParams, menu: tabName})}`)
            )}
            show={queryParams?.modal === "manage"}
            tabName={queryParams?.menu}
        />
        {next()}
    </>,
    // @ts-ignore
    ["responsive", (_, next) => <Responsive {...{
        sizes: {
            md: 1024,
        },
        next,
    }}/>],
    ({accountMenu, queryParams, routerHistory, responsive}) => responsive.lt("md") ? (
        AccountTabsLayout({
            mobileHeader:
                <div className="back-section-5fd">
                    <InternalLink
                        className="back"
                        to='/account/admin/office'
                        xd-qa-type="link"
                        xd-qa-name="Back"
                    >
                        <i className="fa fa-chevron-left"/>
                        Office Management
                    </InternalLink>
                </div>,
            mobileOfficeInfo: HeaderMobile({office, items, activeTab, queryParams, config: accountMenu?.accountingMenu?.subMenu ?? items}),
            activeMenu: "officeManagement",
            activeTab,
            historyPush: false,
            officeId: officeId,
            config: accountMenu?.accountingMenu?.subMenu ?? items,
            next,
        })
    ) : AccountTabsLayout({
            header:
                <div className="office-admin-layout-4ed">
                    <div className="back-section">
                        <InternalLink
                            className="back"
                            to='/account/admin/office'
                            xd-qa-type="link"
                            xd-qa-name="Back"
                        >
                            <i className="fa fa-chevron-left"/>
                            Back to Offices
                        </InternalLink>
                    </div>
                    <div className="office-description">
                        {office?.branchName ? (
                            <div className="name" xd-qa-type="label" xd-qa-name="Branch Name">
                                {office?.branchName}
                                <a
                                    className="office-edit"
                                    xd-qa-type="link"
                                    xd-qa-name="Edit"
                                    onClick={ ()=> (
                                        routerHistory.replace(items.find((item) => activeTab === item.name)?.link + buildUrlQuery({
                                            ...queryParams,
                                            modal: "manage",
                                            menu: "general"
                                        }))
                                    )}
                                    >
                                        Edit
                                </a>
                                <Link
                                    to={"/account/admin/user?office=" + officeId}
                                    xd-qa-type="link"
                                    xd-qa-name="View Users"
                                    className="link-agent"
                                >
                                    View Users
                                </Link>
                            </div>
                        ) : (
                            <div>Loading... </div>
                        )}
                        {office?.branchAddress1 && <div className="address" xd-qa-type="label" xd-qa-name="Address 1"> {office?.branchAddress1 } </div>}
                        {office?.branchAddress2 && <div className="address" xd-qa-type="label" xd-qa-name="Address 2"> {office?.branchAddress2 } </div>}
                        {office?.branchCity && <div className="address" xd-qa-type="label" xd-qa-name="City State Zip">{`${office?.branchCity}, ${office?.branchState} ${office?.branchZip}`}</div>}
                    </div>
                </div>
            ,
            activeMenu: "officeManagement",
            activeTab,
            historyPush: false,
            officeId: officeId,
            config: accountMenu?.accountingMenu?.subMenu ?? items,
            next,
        }),
);

const items = [
    {
        linkLabel: "Address Lists",
        name: "office-address-lists",
        link: "/account/admin/office/address-lists",
    },
    {
        linkLabel: "Mailing Assets",
        name : "office-mailing-assets",
        link: "/account/admin/office/mailing-assets",
    },
];
